/**
 * Testimonial Slides
 */
function init() {
  const $ = window.jQuery;
  const Flickity = require('flickity');
  const $testimonialSlides = $('.is-style-testimonials-slides .testimonials-block__cards');
  if ($testimonialSlides.length) {
    Flickity.prototype._createResizeClass = function () {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function () {
      this.element.classList.remove('flickity-resize');
      resize.call(this);
      this.element.classList.add('flickity-resize');
    };
  }

  for (let i = 0; i < $testimonialSlides.length; i++) {
    new Flickity($testimonialSlides[i], {
      // cellAlign: 'left', // default center
      wrapAround: true,
      // prevNextButtons: false, // default true
      pageDots: false, // default true
      autoPlay: true, // default false, true = 3s
      pauseAutoPlayOnHover: true, // default true
      // selectedAttraction: 0.01,
      // friction: 0.15,
    });

    // $carousel.on('hover', function () {
    //   $carousel.pausePlayer();
    // }, function () {
    //   $carousel.unpausePlayer();
    // });
  }
}

export {init as default}
